import { Validator } from '@vista-digital/validator';
import { defaultMemberRewardListAssets, memberRewardListAssetsValidator } from './assets';
import { defaultMemberRewardListCdnOptions, memberRewardListCdnOptionsValidator } from './cdn-options';
import { defaultMemberRewardListConfig, memberRewardListConfigValidator } from './config';
import { defaultMemberRewardListDisplayText, memberRewardListDisplayTextValidator } from './display-text';
import { memberRewardListEventsValidator } from './events';
export const defaultMemberRewardListProps = {
    config: defaultMemberRewardListConfig,
    displayText: defaultMemberRewardListDisplayText,
    assets: defaultMemberRewardListAssets,
    cdnOptions: defaultMemberRewardListCdnOptions,
    events: {}
};
export const memberRewardListPropsValidator = Validator.object({
    config: memberRewardListConfigValidator,
    displayText: memberRewardListDisplayTextValidator,
    assets: memberRewardListAssetsValidator,
    events: memberRewardListEventsValidator,
    cdnOptions: memberRewardListCdnOptionsValidator
});
